import { render } from "./App.vue?vue&type=template&id=52d96420&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=52d96420&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3368519796/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d96420"]])

export default __exports__